import { render, staticRenderFns } from "./cuponesVigentes.vue?vue&type=template&id=202f7284&scoped=true"
import script from "./cuponesVigentes.vue?vue&type=script&lang=js"
export * from "./cuponesVigentes.vue?vue&type=script&lang=js"
import style0 from "./cuponesVigentes.vue?vue&type=style&index=0&id=202f7284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202f7284",
  null
  
)

export default component.exports